import { Room } from "@/Common/Api/Appointment/Dto/Room";
import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { Email } from "@/Common/Api/Contacts/Dto/Email";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { Guid } from "@/Common/Models/Guid";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";
import { OpeningHour } from "@/Common/Models/Sites/OpeningHour";
import { SiteSpecialtyId } from "@/Common/Models/Sites/SiteSpecialtyId";
import { IClinicLogo } from "../IClinicLogo";
import { SiteIdentifier } from "../SiteIdentifier";

class Site {
    public static readonly defaultMultifactorAuthenticationNumberBadAccess = 20;

    public Id: Guid = GuidHelper.Empty();
    public Version: number = 0;
    public ClinicalName: string = "";
    public ClinicalCode: string = "";
    public IsGMF: boolean = false;
    public IsGMFU: boolean = false;
    public IsGMFR: boolean = false;
    public AssociationId: string = GuidHelper.Empty();
    public SiteLevel: number = 0;
    public ParentSiteId: string = GuidHelper.Empty();
    public RequiredHealthIdentificationForPatients: boolean = false;
    public TimeSlotSizeInMinutes: number = 5;
    public CeLoginRamq: string = "";
    public Acronym: string = "";
    public AddressDsq: string = "";
    public NameDsq: string = "";
    public PostalCodeDsq: string = "";
    public CityDsq: string = "";
    public PhoneDsq: string = "";
    public OIDVersion: string = "";
    public NUI: string = "";
    public GstValue: number = 0;
    public QstValue: number = 0;
    public HstValue: number = 0;
    public GenericTaxValue: number = 0;
    public AipLogin: string = "";
    public AllowedFormTags: string = "";
    public AipPassword: string = "";
    public DisclaimerFr: string = "";
    public DisclaimerEn: string = "";
    public PopularMedication: string = "";
    public NumberBadAccess: number = 3;
    public MultifactorAuthenticationNumberBadAccess = Site.defaultMultifactorAuthenticationNumberBadAccess;
    public PeriodOfInactivityDays: number = 42;
    public LabContext: string = "";
    public ClinicHistoricalIds: string = "";
    public GSTCode: string = "";
    public QSTCode: string = "";
    public UnapproveNoteExpiryInMinutes: number = 20160; // 20160 = 2 weeks
    public EnforceDiagnosisSelection: boolean = false;
    public MspLocationCode: string = "";
    public BookingHubEnabled: boolean = false;
    public GoLiveDate: Date = null;

    // those variable is used for Combo/Service search in the Appointment search component.
    public anySelected: boolean = false;
    public duration: number = 10;
    public InterfaceId: string = "";

    public Phones: PhoneNumber[] = [];
    public Adresses: Address[] = [];
    public Emails: Email[] = [];
    public Rooms: Room[] = [];
    public MainEnrolmentSiteForClinicalCode: boolean;
    public PayeeNumber: string = "";
    public MspFacilityNumber: string = "";
    public LocalizedDisplayName?: LocalizedTextDto;
    public Specialties: SiteSpecialtyId[] = [];
    public OfferedSpecialtyIds: string[] = [];
    public OpeningHours: OpeningHour[];
    public LocalizedWebsite?: LocalizedTextDto;
    public LocalizedDescription?: LocalizedTextDto;
    public LocalizedKioskInstruction?: LocalizedTextDto;
    public LocalizedOpeningHoursNote?: LocalizedTextDto;
    public LogoAttachments: IClinicLogo[] = [];
    public SiteIdentifiers: SiteIdentifier[] = [];
    public RequireAppointmentLinkToSignNote: boolean;

    constructor(fields?: Partial<Site>) {
        Object.assign(this, fields);
    }

    public static ToComboboxItem(site: Site): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(site.Id, site.ClinicalName, 0);
    }
}

export { Site };
